import React from 'react';
import { Moon, Sun } from 'lucide-react';

type Props = {
  dark: boolean;
  onChange: (dark: boolean) => void;
};

const LearnDarkModeToggle: React.FC<Props> = ({ dark, onChange }) => (
  <div className="learn-dark-toggle pointer-events-auto fixed bottom-5 right-4 z-[70] sm:bottom-6 sm:right-6">
    <label className="flex items-center gap-2 rounded-full border px-3 py-2 shadow-lg cursor-pointer select-none">
      {dark ? <Moon className="h-4 w-4 shrink-0" aria-hidden /> : <Sun className="h-4 w-4 shrink-0" aria-hidden />}
      <span className="text-xs font-semibold whitespace-nowrap">Dark mode</span>
      <button
        type="button"
        role="switch"
        aria-checked={dark}
        aria-label="Dark mode"
        className={`relative h-5 w-9 shrink-0 rounded-full transition-colors ${dark ? 'bg-primary-500' : 'bg-gray-300'}`}
        onClick={() => onChange(!dark)}
      >
        <span
          className={`absolute top-0.5 left-0.5 h-4 w-4 rounded-full bg-white shadow transition-transform ${dark ? 'translate-x-4' : 'translate-x-0'}`}
        />
      </button>
    </label>
  </div>
);

export default LearnDarkModeToggle;
